import React, { useState, useEffect, useRef } from 'react';
import './Header.scss';

interface HeaderProps {
  onToggleSidebar: () => void;
  sidebarCollapsed: boolean;
  onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ onToggleSidebar, sidebarCollapsed, onLogout }) => {
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const adminUser = JSON.parse(localStorage.getItem('admin_user') || '{}');

  // Close dropdown when clicking anywhere outside the user-menu container
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setUserDropdownOpen(false);
      }
    };
    if (userDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [userDropdownOpen]);

  return (
    <header className="admin-header">
      <div className="header-left">
        <button 
          className="sidebar-toggle"
          onClick={onToggleSidebar}
          title={sidebarCollapsed ? 'Išskleisti meniu' : 'Suskleisti meniu'}
        >
          <span className={`hamburger ${sidebarCollapsed ? 'collapsed' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>

      <div className="header-right">
        <div className="user-menu" ref={menuRef}>
          <button 
            className="user-button"
            onClick={() => setUserDropdownOpen(!userDropdownOpen)}
          >
            <div className="user-avatar">
              {adminUser.name?.charAt(0) || 'A'}
            </div>
            <div className="user-info">
              <span className="user-name">{adminUser.name || 'Admin User'}</span>
              <span className="user-role">Administratorius</span>
            </div>
            <span className={`dropdown-arrow ${userDropdownOpen ? 'open' : ''}`}>
              ▼
            </span>
          </button>

          {userDropdownOpen && (
            <div className="user-dropdown">
              <button className="dropdown-item logout" onClick={onLogout}>
                <span>🚪</span>
                <span>Atsijungti</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
